export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8534.1f2417ba.jpg";